import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { PhoneIssuesChipAndMenuModule } from 'src/app/common-components/phone-issues-chip-and-menu/phone-issues-chip-and-menu.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { FormatPhoneNumberorExtensionPipeModule } from 'src/app/pipes/format-phone-number-or-extension/format-phone-number-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddFindMeFollowMeStepModule } from '../add-find-me-follow-me-step/add-find-me-follow-me-step.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { DeviceDetailComponent } from './containers/device-detail.component';
import { DeviceDetailEffects } from './state/device-detail.effects';
import * as fromDeviceDetail from './state/device-detail.reducer';
import { DeviceDetailViewComponent } from './views/device-detail-view.component';
@NgModule({
   declarations: [DeviceDetailViewComponent, DeviceDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      RouterModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      PhoneIssuesChipAndMenuModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      LcsDatepickerModule,
      MatChipsModule,
      TwoColumnLayoutModule,
      DragDropModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      EntitySelectModule,
      StoreModule.forFeature(fromDeviceDetail.deviceDetailFeatureKey, fromDeviceDetail.reducer),
      EffectsModule.forFeature([DeviceDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
      ErrorPageModule,
      DragDropModule,
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      MatIconModule,
      MatTooltipModule,
      MatButtonModule,
      FileUrlPipeModule,
      MatCheckboxModule,
      MatMenuModule,
      LcsLoadingOverlayModule,
      AddFindMeFollowMeStepModule,
      FormatPhoneNumberorExtensionPipeModule,
      MatChipsModule,
   ],
})
export class DeviceDetailModule {}
